export interface IOrderCouponUsage {
  name?: string;
  discount_type?: string;
  discount_amount?: number;
}

export interface IOrderCouponSummaryItem {
  name: string;
  discountType: string;
  discountAmount: number;
  deductedAmount: number;
}

export interface IOrderCouponSummary {
  items: IOrderCouponSummaryItem[];
  totalDiscount: number;
  totalAfterDiscount: number;
}

export const calculateCouponSummary = (
  subtotal: number,
  couponUsages: IOrderCouponUsage[] = []
): IOrderCouponSummary => {
  const items = couponUsages.map((coupon) => {
    const discountAmount = Number(coupon.discount_amount ?? 0);
    const discountType = coupon.discount_type ?? 'absolute';
    const deductedAmount =
      discountType === 'percentage'
        ? subtotal * (discountAmount / 100)
        : discountAmount;

    return {
      name: coupon.name ?? 'Coupon',
      discountType,
      discountAmount,
      deductedAmount,
    };
  });

  const totalDiscount = items.reduce((sum, item) => sum + item.deductedAmount, 0);

  return {
    items,
    totalDiscount,
    totalAfterDiscount: Math.max(0, subtotal - totalDiscount),
  };
};
